import { render, staticRenderFns } from "./ClientContacts.vue?vue&type=template&id=5d4819dd&scoped=true&"
import script from "./ClientContacts.vue?vue&type=script&lang=js&"
export * from "./ClientContacts.vue?vue&type=script&lang=js&"
import style0 from "./ClientContacts.vue?vue&type=style&index=0&id=5d4819dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4819dd",
  null
  
)

export default component.exports